<template>
  <div class="hub-sunset">
    <div class="hub-sunset__decor hub-sunset__decor--tl" aria-hidden="true" />
    <div class="hub-sunset__decor hub-sunset__decor--br" aria-hidden="true" />

    <div class="hub-sunset__card">
      <h1 class="hub-sunset__title">Thông báo điều hướng</h1>
      <p class="hub-sunset__lead">
        Trang web sắp hết hạn. Vui lòng sử dụng địa chỉ mới bên dưới cho tài khoản của bạn.
      </p>

      <p v-if="loading" class="hub-sunset__status">Đang tải thông tin điều hướng…</p>

      <p v-else-if="!hasLinks" class="hub-sunset__warn">
        Không xác định được địa chỉ cho tài khoản của bạn. Liên hệ quản trị viên hoặc bộ phận IT.
      </p>

      <div v-else class="hub-sunset__links">
        <a
          v-for="item in navigationLinks"
          :key="item.key"
          :href="item.url"
          class="hub-sunset__link-btn"
          rel="noopener noreferrer"
        >
          <span class="hub-sunset__link-label">{{ item.label }}</span>
          <span class="hub-sunset__link-sep">—</span>
          <span class="hub-sunset__link-url">{{ item.url }}</span>
        </a>
      </div>

      <p v-if="supportFormUrl" class="hub-sunset__support">
        Nếu hệ thống mới thiếu các tính năng bạn cần có để làm việc hoặc cần các quyền riêng, hãy điền vào form sau và chờ phê duyệt.
        <a :href="supportFormUrl" target="_blank" rel="noopener noreferrer" class="hub-sunset__support-link">Ấn vào đây</a>
      </p>

      <button type="button" class="hub-sunset__logout" @click="onLogout">
        Đăng xuất
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { loadSsoConfig } from "@/helper/sso";
import {
  isHubSunsetFeatureEnabled,
  clearHubSunsetStorage,
} from "@/helper/hubSunset";

const NOTICE_STORAGE_KEY = "chat_launch_notice";

export default {
  name: "HubSunset",

  data() {
    return {
      loading: false,
      localNotice: null,
    };
  },

  computed: {
    notice() {
      return this.localNotice || this.$store.state.auth.chatLaunchNotice;
    },
    navigationLinks() {
      const links = this.notice && this.notice.navigation_links;
      return Array.isArray(links) ? links.filter((l) => l && l.url) : [];
    },
    hasLinks() {
      return this.navigationLinks.length > 0;
    },
    supportFormUrl() {
      const u = this.notice && this.notice.support_form_url;
      return u && String(u).trim() ? String(u).trim() : "";
    },
  },

  async mounted() {
    await loadSsoConfig().catch(() => undefined);

    if (!isHubSunsetFeatureEnabled()) {
      clearHubSunsetStorage();
      this.$store.commit("setChatLaunchNotice", null);
      const token = localStorage.getItem("access_token");
      if (token) {
        this.$router.replace({ name: "New Feeds" });
      } else {
        this.$router.replace({ name: "Login" });
      }
      return;
    }

    this.hydrateNoticeInner();
  },

  methods: {
    hydrateNotice() {
      this.hydrateNoticeInner();
    },

    hydrateNoticeInner() {
      const fromStore = this.$store.state.auth.chatLaunchNotice;
      if (fromStore && fromStore.show) {
        this.localNotice = fromStore;
        return;
      }

      try {
        const raw = sessionStorage.getItem(NOTICE_STORAGE_KEY);
        if (raw) {
          const parsed = JSON.parse(raw);
          if (parsed && parsed.show) {
            this.localNotice = parsed;
            this.$store.commit("setChatLaunchNotice", parsed);
            return;
          }
        }
      } catch (e) {
        /* ignore */
      }

      this.fetchNotice();
    },

    fetchNotice() {
      const token = localStorage.getItem("access_token");
      if (!token) {
        this.$router.replace({ name: "Login" });
        return;
      }

      this.loading = true;
      axios
        .get("/auth/hub-sunset")
        .then((res) => {
          const body = res.data;
          const payload = body && body.data ? body.data : null;
          if (payload && payload.show) {
            this.localNotice = payload;
            this.$store.commit("setChatLaunchNotice", payload);
            sessionStorage.setItem(NOTICE_STORAGE_KEY, JSON.stringify(payload));
            return;
          }
          this.$router.replace({ name: "New Feeds" });
        })
        .catch(() => {
          this.$router.replace({ name: "New Feeds" });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onLogout() {
      sessionStorage.removeItem(NOTICE_STORAGE_KEY);
      this.$store.dispatch("logout");
    },
  },
};
</script>

<style scoped>
.hub-sunset {
  position: fixed;
  inset: 0;
  z-index: 10050;
  min-height: 100vh;
  min-height: 100svh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: linear-gradient(145deg, #2b7fd4 0%, #4a9fe8 45%, #5eb0f0 100%);
  overflow: auto;
}

.hub-sunset__decor {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  opacity: 0.35;
}

.hub-sunset__decor--tl {
  width: 220px;
  height: 220px;
  top: -60px;
  left: -40px;
  border: 3px solid rgba(255, 255, 255, 0.25);
}

.hub-sunset__decor--br {
  width: 160px;
  height: 160px;
  bottom: 8%;
  right: 5%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, transparent 70%);
}

.hub-sunset__card {
  position: relative;
  width: 100%;
  max-width: 720px;
  padding: 2.5rem 2.25rem 2rem;
  text-align: center;
  color: #fff;
  background: rgba(12, 45, 92, 0.82);
  border-radius: 4px;
  box-shadow: 0 24px 64px rgba(0, 30, 80, 0.35);
}

.hub-sunset__title {
  margin: 0 0 1rem;
  font-size: 1.65rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.hub-sunset__lead {
  margin: 0 auto 1.75rem;
  max-width: 520px;
  font-size: 0.95rem;
  line-height: 1.55;
  opacity: 0.95;
}

.hub-sunset__status {
  margin: 0 0 1.5rem;
  font-size: 0.9rem;
  opacity: 0.85;
}

.hub-sunset__warn {
  margin: 0 0 1.5rem;
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 6px;
}

.hub-sunset__links {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  margin-bottom: 1.5rem;
}

.hub-sunset__link-btn {
  display: block;
  padding: 0.85rem 1.25rem;
  font-size: 0.9rem;
  font-weight: 500;
  line-height: 1.4;
  color: #111 !important;
  text-decoration: none !important;
  background: #fff;
  border-radius: 999px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.hub-sunset__link-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.18);
}

.hub-sunset__link-label {
  font-weight: 600;
}

.hub-sunset__link-sep {
  margin: 0 0.35rem;
}

.hub-sunset__link-url {
  word-break: break-all;
}

.hub-sunset__support {
  margin: 0 0 1.5rem;
  font-size: 0.8rem;
  line-height: 1.55;
  opacity: 0.9;
}

.hub-sunset__support-link {
  color: #7ec8ff !important;
  font-weight: 600;
  text-decoration: underline !important;
}

.hub-sunset__logout {
  display: inline-block;
  min-width: 140px;
  padding: 0.5rem 1.75rem;
  font-size: 0.9rem;
  color: #fff;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.65);
  border-radius: 999px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.hub-sunset__logout:hover {
  background: rgba(255, 255, 255, 0.1);
}

@media (max-width: 600px) {
  .hub-sunset__card {
    padding: 1.75rem 1.25rem 1.5rem;
  }

  .hub-sunset__link-btn {
    font-size: 0.8rem;
    border-radius: 12px;
  }

  .hub-sunset__link-sep {
    display: block;
    margin: 0.25rem 0;
  }
}
</style>
